export default {"src":"https://js-static.iimjobs.com/production/6.4.3/_next/static/media/cal.5daa8258.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};